import { Routes, Route } from 'react-router-dom';
import LoginWrapper from 'components/login/LoginWrapper';
import OnboadingWrapper from 'components/login/OnboadingWrapper';
import { BusinessRouteRedirect, MainRoute } from 'components/BizChatRedirect';


const Router = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginWrapper />} />
      <Route path="/onboarding" element={<OnboadingWrapper />} />
      <Route path="/" element={<MainRoute />} />
      <Route path="/room/:channelId" element={<MainRoute />} />
      <Route path="/business/:bizId/:channelId" element={<BusinessRouteRedirect />} />
      <Route path="/business/:bizId" element={<BusinessRouteRedirect />} />
    </Routes>
  );
};

export default Router;
